import React from 'react';
import { URL_BASE } from "@utils/auth";
import useTable from '@hooks/useTable';

import { Row, Col } from 'react-bootstrap';
import { Table, Input, Tag } from 'antd';
import noImage from '@assets/not-found.jpg';

export default function PageCollaborator() {
    const { dataSource, handleSearched } = useTable('/collaborator/');
    
    const columns = [
        {
            title: '',
            width: '100px',
            render: data => <img src={data.foto === null ? noImage : `${URL_BASE}/${data.foto}`} width="100%" />
        }, {
            title: 'Geral',
            render: data => (
                <>
                    <div><b>Nome:</b> {data.nome}</div>
                    <div><b>Contato:</b> {data.email} / <span className="maskTelefone">{data.celular}</span></div>
                </>
            )
        }, {
            title: 'Setor / Função',
            render: data => (
                <>
                    <div>
                        <b>Admissão:</b> <input disabled type="date" value={data.admissao} />
                    </div>
                    {data.demissao !== null && (
                        <Tag color="volcano">
                            <b>Demissão:</b> <input disabled type="date" value={data.demissao} />
                        </Tag>
                    )}
                    <div>
                        <b>Função:</b> {data.setor} - {data.cargo}
                    </div>
                </>
            )
        }, {
            title: 'Ação',
            key: 'acao',
            align: 'right',
            width: '30%',
            render: data => (
                <a href={`/colaboradores/update/${data.id_collaborator}`} className="btn btn-primary">
                    <i className="icon-note" /> Editar
                </a>
            )
        }
    ];

    return (
        <div className="bg-padrao">
            <Row>
                <Col md="6">
                    <h1>Nossos Colaboradores</h1>
                </Col>
                <Col md="6" className="text-right">
                    <a href="/colaboradores/create" className="btn btn-success">
                        <i className="icon-plus"></i>
                        Cadastrar Novo
                    </a>
                </Col>
            </Row>
            <div className="hardLine"></div>
            <Row className="justify-content-end">
                <Col md="3">
                    <div className="input-icon">
                        <Input onChange={handleSearched} placeholder="Procurar" />
                        <i className="icon-magnifier" />
                    </div>
                </Col>
            </Row>
            <Table
                columns={columns}
                dataSource={dataSource.dataTable}
                loading={dataSource.loading}
                pagination={{pageSize: 20}}
            />
        </div>
    )
}